import { ReportLocationStats, ChannelLocation, LocationDetails } from '@dev/ee-api/ee-api-models';

import {
    LocationWorldParams,
    LocationWorldChannelParams,
    // LocationCountryParams,
    LocationCountryChannelParams,
    LocationCountryParams,
} from '@/store/activity/locations/types';
import { request } from './request';

export const loadLocationActivity = (params: LocationWorldParams): Promise<ReportLocationStats[]> => {
    const { Activity } = request();

    return Activity.reportsLocationsGet(
        params.from,
        params.to,
        params.limit,
        params.offset,
        params.sortBy,
        params.sortDescending,
        params.onlyWithData
    ).then((resp): ReportLocationStats[] => resp.data);
};

export const getWorldChannelLocation = (params: LocationWorldChannelParams): Promise<ChannelLocation> => {
    const { Campaigns } = request();

    return Campaigns.campaignsByNameLocationsGet(params.name, params.from, params.to).then(
        (resp): ChannelLocation => resp.data
    );
};

export const getCountryLocation = (params: LocationCountryParams): Promise<LocationDetails[]> => {
    const { Activity } = request();
    return Activity.reportsByCountryisoLocationsGet(params.countryiso, params.from, params.to).then(
        (resp): LocationDetails[] => resp.data
    );
};

export const getCountryChannelLocations = (params: LocationCountryChannelParams): Promise<LocationDetails[]> => {
    const { Campaigns } = request();

    return Campaigns.campaignsByNameByCountryisoLocationsGet(
        params.countryiso,
        params.name,
        params.from,
        params.to
    ).then((resp): LocationDetails[] => resp.data);
};
